import { createRoot } from 'react-dom/client'

import { parsePageContext } from '../../lib/context/base'
import { catalogToArray, transformCatalogForWidget } from '../../lib/data-fetching/catalog-transform'
import { fetchShowCatalogProductsForRegionClient } from '../../lib/data-fetching/client'
import { processCategoryData } from '../../lib/data-fetching/library'
import { SHOWS_CATEGORY_ID, SHOWS_USER_JOURNEY_TYPE } from '../../lib/shows-config'
import { ShowsController } from './shows-controller'

export const injectShowsWidget = async (container: HTMLElement) => {
  // Parse context from container data attributes
  const context = parsePageContext(container)

  // Create React root first to show loading state
  const root = createRoot(container)

  root.render(<ShowsController context={context} regularList={[]} productsMapFiltered={{}} viewState="loading" />)

  // Fetch data dynamically on each render
  let regularList: any[] = []
  let productsMapFiltered: Record<string, any> = {}
  let viewState: 'loading' | 'loaded' | 'noData' | 'hasError'

  try {
    // Fetch events from API (client-side, every render)
    const catalogData = await fetchShowCatalogProductsForRegionClient(context.region)

    if (catalogData && catalogData.length > 0) {
      try {
        // Transform from SEO format to widget format
        const widgetCatalog = transformCatalogForWidget(catalogData)
        const catalogArray = catalogToArray(widgetCatalog)

        // Process the category data
        const categoryData = processCategoryData(catalogArray, SHOWS_CATEGORY_ID, SHOWS_USER_JOURNEY_TYPE)

        if (categoryData) {
          regularList = categoryData.regularList
          productsMapFiltered = categoryData.productsMapFiltered
          viewState = categoryData.viewState
        } else {
          viewState = 'noData'
        }
      } catch (error) {
        console.error('[Cards List Widget] Failed to process catalog data:', error)
        viewState = 'hasError'
      }
    } else {
      viewState = 'noData'
    }
  } catch (error) {
    console.error('[Cards List Widget] Failed to fetch catalog data:', error)
    viewState = 'hasError'
  }

  // Re-render with fetched data
  root.render(
    <ShowsController
      context={context}
      regularList={regularList}
      productsMapFiltered={productsMapFiltered}
      viewState={viewState}
    />,
  )
}
